export default "__VITE_ASSET__60168502__"